import {accountBenefitsContent} from './account/account-benefits'
import {oneOnOneRoomsContent} from './features/1-on-1-rooms'
import {groupRoomsContent} from './features/group-rooms'
// import {premiumSubscriptionContent} from './billing/premium-subscription'
import {reportingAnAccountContent} from './reporting/reporting-an-account'
import {blockingAndMutingContent} from './safety/moderation'

export interface HelpArticle {
  slug: string
  title: string
  summary: string
  content: string
}

export interface HelpCategory {
  slug: string
  title: string
  description: string
  articles: HelpArticle[]
}

export const helpCategories: HelpCategory[] = [
  {
    slug: 'account',
    title: 'Account',
    description: 'Managing your account, profile, and login',
    articles: [
      {
        slug: 'account-benefits',
        title: 'Account Benefits',
        summary:
          'Learn what your Batesky account includes and how to get started.',
        content: accountBenefitsContent,
      },
    ],
  },
  // {
  //   slug: 'billing',
  //   title: 'Billing',
  //   description: 'Subscriptions, payments, and premium features',
  //   articles: [
  //     {
  //       slug: 'premium-subscription',
  //       title: 'Premium Subscription',
  //       summary: 'Learn about premium features and how to subscribe.',
  //       content: premiumSubscriptionContent,
  //     },
  //   ],
  // },
  // {
  //   slug: 'reporting',
  //   title: 'Reporting',
  //   description: 'How to report content, accounts, and issues',
  //   articles: [
  //     {
  //       slug: 'reporting-an-account',
  //       title: 'Reporting a Post or an Account',
  //       summary: 'How to report a post or user account for violations.',
  //       content: reportingAnAccountContent,
  //     },
  //   ],
  // },
  {
    slug: 'batesky-features',
    title: 'Features',
    description: 'Unique features available on Batesky',
    articles: [
      {
        slug: '1-on-1-rooms',
        title: '1 on 1 Rooms',
        summary: 'Start a private 1 on 1 room to cam with your bro.',
        content: oneOnOneRoomsContent,
      },
      {
        slug: 'group-rooms',
        title: 'Group Rooms',
        summary: 'Group Rooms are coming soon!',
        content: groupRoomsContent,
      },
    ],
  },
  {
    slug: 'safety',
    title: 'Safety',
    description: 'Staying safe, privacy settings, and blocking',
    articles: [
      {
        slug: 'moderation',
        title: 'Moderation',
        summary: 'Control who can interact with you and what you see.',
        content: blockingAndMutingContent,
      },
      {
        slug: 'reporting-an-account',
        title: 'Reporting a Post or an Account',
        summary: 'How to report a post or user account for violations.',
        content: reportingAnAccountContent,
      },
    ],
  },
]

export function findCategory(categorySlug: string): HelpCategory | undefined {
  return helpCategories.find(c => c.slug === categorySlug)
}

export function findArticle(
  categorySlug: string,
  articleSlug: string,
): HelpArticle | undefined {
  const cat = findCategory(categorySlug)
  return cat?.articles.find(a => a.slug === articleSlug)
}
